import axios from 'axios';

export default function postUploadFileToPresignedUrl(url, fields, fileToUpload, bucket) {
    const data = new FormData();
    Object.keys(fields).forEach(field => data.append(field, fields[field]));
    data.append('bucket', bucket);
    data.append('file', fileToUpload);

    return dispatch => dispatch({
        type: 'UPLOAD_FILE_TO_PRESIGNED_URL',
        payload: axios({ method: 'post', url, data })
    });
}


// WEBPACK FOOTER //
// ./src/actions/postUploadFileToPresignedUrl.js